// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Xjd_h","label":"styles_label__J18aI"};